import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NgClass } from '@angular/common';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';
import { getIndexClass } from '../../util/index.util';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-benefits',
  imports: [
    NzRowDirective,
    NzColDirective,
    NzTypographyComponent,
    NzCardComponent,
    NgClass,
  ],
  templateUrl: './benefits.component.html',
  styleUrl: './benefits.component.less',
})
export class BenefitsComponent {
  public readonly benefitsDTO: InputSignal<IBenefitsDTO> =
    input.required<IBenefitsDTO>();
  public getIndexClass: (index: number) => string = getIndexClass;

  public getSpanValue(
    size: 'lg' | 'md' | 'sm' | 'xl' | 'xs',
    count: number,
    index: number,
    last: boolean,
    odd: boolean
  ): number {
    if (['md', 'sm', 'xs'].includes(size)) {
      return 24;
    }
    if ('lg' === size) {
      return 12;
    }
    if (0 !== count % 2 && last) {
      return 24;
    }
    if (odd) {
      if (0 === (index + 1) % 4) {
        return 10;
      }
      return 14;
    }
    if (0 === (index + 1) % 3) {
      return 14;
    }
    return 10;
  }
}
